import { Card as MCard, CardProps } from '@mui/material'

export const Card: React.FC<CardProps> = (props) => {
  return <MCard {...props} />
}
